// proto/v2/prompt/prompt.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file prompt/prompt.proto (package lvdr.v2.prompt, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file prompt/prompt.proto.
 */
export const file_prompt_prompt: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message lvdr.v2.prompt.ConversationMessage
 */
export type ConversationMessage = Message<"lvdr.v2.prompt.ConversationMessage"> & {
  /**
   * @generated from field: lvdr.v2.prompt.MessageRole role = 1;
   */
  role: MessageRole;

  /**
   * @generated from field: string content = 2;
   */
  content: string;
};

/**
 * Describes the message lvdr.v2.prompt.ConversationMessage.
 * Use `create(ConversationMessageSchema)` to create a new message.
 */
export const ConversationMessageSchema: GenMessage<ConversationMessage> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 0);

/**
 * @generated from message lvdr.v2.prompt.GraphLimits
 */
export type GraphLimits = Message<"lvdr.v2.prompt.GraphLimits"> & {
  /**
   * @generated from field: int32 max_nodes = 1;
   */
  maxNodes: number;

  /**
   * @generated from field: int32 max_depth = 2;
   */
  maxDepth: number;

  /**
   * @generated from field: int32 max_children = 3;
   */
  maxChildren: number;
};

/**
 * Describes the message lvdr.v2.prompt.GraphLimits.
 * Use `create(GraphLimitsSchema)` to create a new message.
 */
export const GraphLimitsSchema: GenMessage<GraphLimits> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 1);

/**
 * @generated from message lvdr.v2.prompt.QuestionOption
 */
export type QuestionOption = Message<"lvdr.v2.prompt.QuestionOption"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message lvdr.v2.prompt.QuestionOption.
 * Use `create(QuestionOptionSchema)` to create a new message.
 */
export const QuestionOptionSchema: GenMessage<QuestionOption> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 2);

/**
 * @generated from message lvdr.v2.prompt.StructuredQuestion
 */
export type StructuredQuestion = Message<"lvdr.v2.prompt.StructuredQuestion"> & {
  /**
   * @generated from field: string question = 1;
   */
  question: string;

  /**
   * @generated from field: lvdr.v2.prompt.QuestionType type = 2;
   */
  type: QuestionType;

  /**
   * @generated from field: repeated lvdr.v2.prompt.QuestionOption options = 3;
   */
  options: QuestionOption[];
};

/**
 * Describes the message lvdr.v2.prompt.StructuredQuestion.
 * Use `create(StructuredQuestionSchema)` to create a new message.
 */
export const StructuredQuestionSchema: GenMessage<StructuredQuestion> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 3);

/**
 * @generated from message lvdr.v2.prompt.PromptSection
 */
export type PromptSection = Message<"lvdr.v2.prompt.PromptSection"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;
};

/**
 * Describes the message lvdr.v2.prompt.PromptSection.
 * Use `create(PromptSectionSchema)` to create a new message.
 */
export const PromptSectionSchema: GenMessage<PromptSection> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 4);

/**
 * @generated from message lvdr.v2.prompt.PromptBuilderSuggestion
 */
export type PromptBuilderSuggestion = Message<"lvdr.v2.prompt.PromptBuilderSuggestion"> & {
  /**
   * @generated from field: string suggested_prompt = 1;
   */
  suggestedPrompt: string;

  /**
   * @generated from field: string suggested_profile = 2;
   */
  suggestedProfile: string;

  /**
   * @generated from field: string profile_explanation = 3;
   */
  profileExplanation: string;

  /**
   * @generated from field: lvdr.v2.prompt.GraphLimits suggested_limits = 4;
   */
  suggestedLimits?: GraphLimits | undefined;

  /**
   * @generated from field: string limits_explanation = 5;
   */
  limitsExplanation: string;

  /**
   * @generated from field: repeated lvdr.v2.prompt.PromptSection sections = 6;
   */
  sections: PromptSection[];

  /**
   * @generated from field: repeated string exclusions = 7;
   */
  exclusions: string[];
};

/**
 * Describes the message lvdr.v2.prompt.PromptBuilderSuggestion.
 * Use `create(PromptBuilderSuggestionSchema)` to create a new message.
 */
export const PromptBuilderSuggestionSchema: GenMessage<PromptBuilderSuggestion> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 5);

/**
 * @generated from message lvdr.v2.prompt.ListProfilesRequest
 */
export type ListProfilesRequest = Message<"lvdr.v2.prompt.ListProfilesRequest"> & {
};

/**
 * Describes the message lvdr.v2.prompt.ListProfilesRequest.
 * Use `create(ListProfilesRequestSchema)` to create a new message.
 */
export const ListProfilesRequestSchema: GenMessage<ListProfilesRequest> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 6);

/**
 * @generated from message lvdr.v2.prompt.SendPromptBuilderMessageRequest
 */
export type SendPromptBuilderMessageRequest = Message<"lvdr.v2.prompt.SendPromptBuilderMessageRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated lvdr.v2.prompt.ConversationMessage conversation_history = 3;
   */
  conversationHistory: ConversationMessage[];

  /**
   * @generated from field: string template_id = 4;
   */
  templateId: string;
};

/**
 * Describes the message lvdr.v2.prompt.SendPromptBuilderMessageRequest.
 * Use `create(SendPromptBuilderMessageRequestSchema)` to create a new message.
 */
export const SendPromptBuilderMessageRequestSchema: GenMessage<SendPromptBuilderMessageRequest> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 7);

/**
 * @generated from message lvdr.v2.prompt.GetTemplatesRequest
 */
export type GetTemplatesRequest = Message<"lvdr.v2.prompt.GetTemplatesRequest"> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string;
};

/**
 * Describes the message lvdr.v2.prompt.GetTemplatesRequest.
 * Use `create(GetTemplatesRequestSchema)` to create a new message.
 */
export const GetTemplatesRequestSchema: GenMessage<GetTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 8);

/**
 * @generated from message lvdr.v2.prompt.ListProfilesResponse
 */
export type ListProfilesResponse = Message<"lvdr.v2.prompt.ListProfilesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.prompt.Profile profiles = 1;
   */
  profiles: Profile[];
};

/**
 * Describes the message lvdr.v2.prompt.ListProfilesResponse.
 * Use `create(ListProfilesResponseSchema)` to create a new message.
 */
export const ListProfilesResponseSchema: GenMessage<ListProfilesResponse> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 9);

/**
 * @generated from message lvdr.v2.prompt.GetTemplatesResponse
 */
export type GetTemplatesResponse = Message<"lvdr.v2.prompt.GetTemplatesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.prompt.Template templates = 1;
   */
  templates: Template[];
};

/**
 * Describes the message lvdr.v2.prompt.GetTemplatesResponse.
 * Use `create(GetTemplatesResponseSchema)` to create a new message.
 */
export const GetTemplatesResponseSchema: GenMessage<GetTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 10);

/**
 * @generated from message lvdr.v2.prompt.PromptBuilderMessageEvent
 */
export type PromptBuilderMessageEvent = Message<"lvdr.v2.prompt.PromptBuilderMessageEvent"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: bool is_complete = 3;
   */
  isComplete: boolean;

  /**
   * @generated from field: lvdr.v2.prompt.PromptBuilderSuggestion suggestion = 4;
   */
  suggestion?: PromptBuilderSuggestion | undefined;

  /**
   * @generated from field: repeated lvdr.v2.prompt.StructuredQuestion questions = 5;
   */
  questions: StructuredQuestion[];
};

/**
 * Describes the message lvdr.v2.prompt.PromptBuilderMessageEvent.
 * Use `create(PromptBuilderMessageEventSchema)` to create a new message.
 */
export const PromptBuilderMessageEventSchema: GenMessage<PromptBuilderMessageEvent> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 11);

/**
 * @generated from message lvdr.v2.prompt.Profile
 */
export type Profile = Message<"lvdr.v2.prompt.Profile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string use_case = 4;
   */
  useCase: string;

  /**
   * @generated from field: repeated string recommended_for = 5;
   */
  recommendedFor: string[];

  /**
   * @generated from field: lvdr.v2.prompt.GraphLimits graph_limits = 6;
   */
  graphLimits?: GraphLimits | undefined;
};

/**
 * Describes the message lvdr.v2.prompt.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 12);

/**
 * @generated from message lvdr.v2.prompt.Template
 */
export type Template = Message<"lvdr.v2.prompt.Template"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;
};

/**
 * Describes the message lvdr.v2.prompt.Template.
 * Use `create(TemplateSchema)` to create a new message.
 */
export const TemplateSchema: GenMessage<Template> = /*@__PURE__*/
  messageDesc(file_prompt_prompt, 13);

/**
 * @generated from enum lvdr.v2.prompt.MessageRole
 */
export enum MessageRole {
  /**
   * @generated from enum value: MESSAGE_ROLE_UNSPECIFIED = 0;
   */
  MESSAGE_ROLE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: ASSISTANT = 2;
   */
  ASSISTANT = 2,
}

/**
 * Describes the enum lvdr.v2.prompt.MessageRole.
 */
export const MessageRoleSchema: GenEnum<MessageRole> = /*@__PURE__*/
  enumDesc(file_prompt_prompt, 0);

/**
 * @generated from enum lvdr.v2.prompt.QuestionType
 */
export enum QuestionType {
  /**
   * @generated from enum value: QUESTION_TYPE_UNSPECIFIED = 0;
   */
  QUESTION_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FREE_TEXT = 1;
   */
  FREE_TEXT = 1,

  /**
   * @generated from enum value: SINGLE_CHOICE = 2;
   */
  SINGLE_CHOICE = 2,

  /**
   * @generated from enum value: MULTI_SELECT = 3;
   */
  MULTI_SELECT = 3,
}

/**
 * Describes the enum lvdr.v2.prompt.QuestionType.
 */
export const QuestionTypeSchema: GenEnum<QuestionType> = /*@__PURE__*/
  enumDesc(file_prompt_prompt, 1);

